/**
 * Provider factory for configuring the RecoveryTrac API client.
 *
 * Sets up `BASE_PATH` and imports the generated `ApiModule` so that all
 * generated services resolve the correct API endpoint.  Auth is handled
 * separately by `PlatformBearerInterceptor`.
 *
 * @module
 */

import { Provider } from '@angular/core';
import { BASE_PATH } from './generated/variables';

/**
 * Returns the Angular providers needed to configure the RecoveryTrac API
 * client for a given base URL.
 *
 * Typically called once in the host's bootstrap. Remotes inherit the
 * providers via the shared injector — they should **not** call this again.
 *
 * @param basePath - The root URL of the RecoveryTrac API
 *                   (e.g., `https://localhost:7107`)
 *
 * @example
 * ```typescript
 * bootstrapApplication(AppComponent, {
 *   providers: [
 *     ...provideRecoveryTracApi(environment.webApiBaseUrl),
 *   ],
 * });
 * ```
 */
export function provideRecoveryTracApi(basePath: string): Provider[] {
  return [
    { provide: BASE_PATH, useValue: basePath },
  ];
}
